<template>
    <div id="metode-pembayaran-form">
        <ol class="breadcrumb pull-right">
            <li>
                <router-link :to="{ path: '/' }">Home</router-link>
            </li>
            <li>Pembayaran</li>
            <li>
                <router-link :to="{ path: '/metode-pembayaran' }"
                    >List Metode Pembayaran</router-link
                >
            </li>
            <li class="active">
                {{ !$route.query.id ? "Buat" : "Update" }} Metode Pembayaran
            </li>
        </ol>

        <h1 class="page-header">
            {{ !$route.query.id ? "Buat" : "Update" }} Metode Pembayaran
        </h1>

        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            {{ !$route.query.id ? "Buat" : "Update" }} Metode
                            Pembayaran
                        </h4>
                    </div>
                    <div class="panel-body">
                        <div
                            class="alert alert-danger fade in m-b-15"
                            v-if="this.errors.length > 0"
                        >
                            <span class="close" data-dismiss="alert"
                                >&times;</span
                            >
                            <strong>Terjadi kesalahan!</strong>
                            <ul>
                                <li
                                    v-for="(message, key) in this.errors"
                                    v-bind:key="key"
                                >
                                    {{ message }}
                                </li>
                            </ul>
                        </div>

                        <form>
                            <div class="form-horizontal form-bordered">
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Nama Bank</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="data.bank_name"
                                        />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Atas Nama</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="data.account_name"
                                        />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Nomor Rekening</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="data.account_number"
                                        />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Deskripsi</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <ckeditor
                                            :editor="editor"
                                            v-model="data.description"
                                            :config="editorConfig"
                                        ></ckeditor>
                                        <br />
                                        <span v-if="data.description"
                                            ><i
                                                >({{
                                                    characterCounter(
                                                        data.description,
                                                    )
                                                }}
                                                karakter)</i
                                            ></span
                                        >
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Gambar (Max 1MB)</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <div class="row">
                                            <div
                                                class="col-md-4"
                                                v-if="data.bank_logo"
                                            >
                                                <img
                                                    class="img-fluid"
                                                    :src="data.bank_logo"
                                                />
                                            </div>
                                            <div class="col-md-8">
                                                <input
                                                    type="file"
                                                    class="form-control"
                                                    accept="image/*"
                                                    @change="
                                                        handleChangeBankLogo(
                                                            $event,
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Status</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <select
                                            class="form-control"
                                            v-model="data.status"
                                        >
                                            <option value="">
                                                -- Pilih Status --
                                            </option>
                                            <option :value="status.PUBLISH">
                                                Publish
                                            </option>
                                            <option :value="status.UNPUBLISH">
                                                Unpublish
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <hr />

                        <div class="pull-right">
                            <button
                                v-if="!$route.query.id && !$route.query.liveId"
                                type="button"
                                class="btn btn-success pull-right"
                                @click="saveData()"
                            >
                                Simpan
                            </button>
                            <button
                                v-else
                                type="button"
                                class="btn btn-success pull-right"
                                @click="editData()"
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "metode-pembayaran-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            errors: [],
            queryId: null,
            isLoading: false,
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            selectedBankLogo: null,
            data: {
                bank_name: null,
                account_name: null,
                account_number: null,
                description: null,
                bank_logo: null,
                status: "",
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "blockQuote",
                    "|",
                    "outdent",
                    "indent",
                ],
            },
        };
    },

    mounted: function () {
        if (this.$route.query.id) {
            this.queryId = this.$route.query.id;
            this.fetchData();
        }
    },

    methods: {
        fetchData: function () {
            var context = this;
            var queryId = this.queryId;
            this.isLoading = true;

            SalesService.getMetodePembayaranDetail(queryId, function (result) {
                context.isLoading = false;
                if (result.success) {
                    context.data.bank_name = result.data.bank_name;
                    context.data.account_name = result.data.account_name;
                    context.data.account_number = result.data.account_number;
                    context.data.description = result.data.description;
                    context.data.bank_logo = result.data.bank_logo;
                    context.data.status = result.data.status;
                } else {
                    alert("Terjadi Kesalahan : " + result.message);
                }
            });
        },

        saveData: function () {
            var data = this.data;
            var context = this;
            this.isLoading = true;

            if (this.validateForm()) {
                SalesService.addMetodePembayaran(data, function (result) {
                    if (result.success)
                        context.doUploadBankLogo(result.data.id);
                    else {
                        alert("Terjadi Kesalahan : " + result.message);
                        context.isLoading = false;
                    }
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        editData: function () {
            var data = this.data;
            var id = this.queryId;
            var context = this;
            this.isLoading = true;

            if (this.validateForm()) {
                SalesService.updateMetodePembayaran(
                    id,
                    data,
                    function (result) {
                        context.isLoading = false;
                        if (result.success) context.doUploadBankLogo(id);
                        else alert("Terjadi Kesalahan : " + result.message);
                    },
                );
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        handleChangeBankLogo: function (event) {
            const file = event.target.files[0];
            this.selectedBankLogo = file;
            this.data.bank_logo = URL.createObjectURL(file);
        },

        doUploadBankLogo: function (id) {
            var context = this;
            var bankLogo = this.selectedBankLogo;
            var formData = new FormData();

            if (bankLogo) {
                formData.append("name", bankLogo.name);
                formData.append("file", bankLogo);

                SalesService.uploadMetodePembayaranBankLogo(
                    id,
                    formData,
                    function (result) {
                        if (result.success)
                            context.$router.push({
                                path: "/metode-pembayaran",
                            });
                        else {
                            alert("Gagal Upload Bank Logo : " + result.message);
                            context.isLoading = false;
                        }
                    },
                );
            } else {
                context.$router.push({ path: "/metode-pembayaran" });
            }
        },

        validateForm() {
            this.errors = [];
            if (!this.data.bank_name) this.errors.push("Nama bank wajib diisi");
            if (!this.data.account_name)
                this.errors.push("Atas nama wajib diisi");
            if (!this.data.account_number)
                this.errors.push("Nomor rekening wajib diisi");
            if (this.data.account_number) {
                if (this.data.account_number[0] === 0)
                    this.errors.push(
                        "Nomor rekening tidak boleh diawali angka 0",
                    );
            }
            if (!this.data.description)
                this.errors.push("Deskripsi wajib diisi");
            if (this.data.description) {
                if (this.characterCounter(this.data.description) > 1000) {
                    this.errors.push(
                        "Deskripsi tidak boleh lebih dari 1000 karakter",
                    );
                }
            }
            if (!this.data.bank_logo) this.errors.push("Gambar wajib diisi");
            if (!this.data.status) this.errors.push("Status wajib diisi");
            if (this.selectedBankLogo) {
                if (this.selectedBankLogo.size > 1000000)
                    this.errors.push("Gambar tidak boleh lebih dari 1MB");
            }
            return this.errors.length == 0;
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// MetodePembayaranForm.vue?0ebea99e